import DateFnsUtils from '@date-io/date-fns';
import { es } from 'date-fns/locale';

export const dateFns = new DateFnsUtils({ locale: es });
